import {
  BundleUpdateOtaType,
  OTAVersion,
  Xota2OperationProcessId,
  Xota2OperationProcessItem,
  Xota2UpdateProgress,
  XotaOperationStatus,
} from '@vi-iot/client/index';

export namespace BundleUpdateHelper {
  export function mappingOperationStatus(
    operation: XotaOperationStatus
  ): Xota2OperationProcessItem[] {
    const operationUpdateProcessForMapping: Record<string, Xota2UpdateProgress> = {
      [Xota2OperationProcessId.TCU_STATUS]: operation.tcuStatus,
      [Xota2OperationProcessId.VERIFYING_UPDATE_METHOD]: operation.updateMethod,
      [Xota2OperationProcessId.ZIP_SERVICES]: operation.containerStatus,
      [Xota2OperationProcessId.FILE_TRANSFER]: operation.transferStatus,
      [Xota2OperationProcessId.UPDATE]: operation.updateStatus,
      [Xota2OperationProcessId.REPORT_GENERATION]: operation.reportStatus,
    };

    const isXotaTwo = operation.updateMethod === Xota2UpdateProgress.XOTA_TWO;

    const xota2Operations: Xota2OperationProcessItem[] = [
      {
        id: Xota2OperationProcessId.TCU_STATUS,
        status: operation.tcuStatus,
      },
      {
        id: Xota2OperationProcessId.VERIFYING_UPDATE_METHOD,
        status: operation.updateMethod,
      },
      {
        id: Xota2OperationProcessId.ZIP_SERVICES,
        status: operation.containerStatus,
      },
      {
        id: Xota2OperationProcessId.FILE_TRANSFER,
        status: operation.transferStatus,
      },
      {
        id: Xota2OperationProcessId.UPDATE,
        status: operation.updateStatus,
      },
      {
        id: Xota2OperationProcessId.REPORT_GENERATION,
        status: operation.reportStatus,
      },
    ];

    const defaultOperations: Xota2OperationProcessItem[] = [
      {
        id: Xota2OperationProcessId.TCU_STATUS,
        status: operation.tcuStatus,
      },
      {
        id: Xota2OperationProcessId.VERIFYING_UPDATE_METHOD,
        status: operation.updateMethod,
      },
    ];

    const operationItems: Xota2OperationProcessItem[] = isXotaTwo
      ? xota2Operations
      : defaultOperations;

    const mappedOperationItems: Xota2OperationProcessItem[] = operationItems.map((item) => ({
      ...item,
      status: operationUpdateProcessForMapping[item.id],
    }));

    return mappedOperationItems;
  }

  export function checkIfHaveVersion(otaVersions: OTAVersion[]): boolean {
    return otaVersions.some(
      (item: OTAVersion) => item.otaType === BundleUpdateOtaType.FOTA && item.version
    );
  }
}
